import type { CSSProperties } from 'react'

export const questTotemRootStyleFromBrand = (
  brandColor?: string | null
): CSSProperties => (brandColor ? { '--color-brand': brandColor } as CSSProperties : {})
